import React, { memo } from 'react'
import { Box, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import SortHandler from '@v4/components/common/SortHandler'
import EditableHTML from '@v4/components/common/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import EditableContainer from '@v4/components/common/EditableContainer'
import VideoBlock from '../../../../components/VideoBlock'
import { useContent } from './Content.hooks'

const Content = props => {
	const [
		{
			classes,
			isMobile,
			direction,
			video,
			text,
			textConfig,
			buttonText,
			buttonTextConfig,
			buttonAction,
			buttonLink,
			extraShortcuts,
			textEditable,
			buttonTextEditable,
			textKey,
			buttonTextKey,
		},
		{ handleTextClick, handleButtonClick, handleTextChange, handleButtonTextChange },
	] = useContent(props)

	return (
		<Grid className={clsx(classes.root)} container spacing={5} alignItems="center">
			<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
				<Grid className={classes.videoContainer} item md={6} xs={12}>
					<VideoBlock className={classes.video} value={video} />
				</Grid>
				<Grid item md={6} xs={12} className={classes.textContainer}>
					{(text || buttonText) && (
						<Box width="100%" className={classes.content}>
							<EditableContainer
								visible={!!text}
								fieldConfig={textConfig}
								onAdd={handleTextChange}
								editable={textEditable}
							>
								<EditableHTML
									key={textKey}
									className={classes.text}
									html={text}
									onClick={handleTextClick}
									extraShortcuts={extraShortcuts}
									editable={textEditable}
									onChange={handleTextChange}
								/>
							</EditableContainer>
							<EditableContainer
								visible={!!buttonText}
								fieldConfig={buttonTextConfig}
								onAdd={handleButtonTextChange}
								editable={buttonTextEditable}
								label="Button"
								wrapper={({ children }) => <Box className={classes.buttonContainer}>{children}</Box>}
							>
								<ActionButton
									className={classes.button}
									key={buttonTextKey}
									action={buttonAction}
									editable={buttonTextEditable}
									onChange={handleButtonTextChange}
									href={buttonLink}
									onClick={handleButtonClick}
								>
									{buttonText}
								</ActionButton>
							</EditableContainer>
						</Box>
					)}
				</Grid>
			</SortHandler>
		</Grid>
	)
}

Content.propTypes = {
	text: PropTypes.string,
	textConfig: PropTypes.object,
	video: PropTypes.string,
	onTextClick: PropTypes.func,
	onButtonClick: PropTypes.func,
	extraShortcuts: PropTypes.objectOf(PropTypes.string),
	direction: PropTypes.string,
	mobileDirection: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		videoContainer: PropTypes.string,
		video: PropTypes.string,
		textContainer: PropTypes.string,
		content: PropTypes.string,
		text: PropTypes.string,
		buttonContainer: PropTypes.string,
	}),
	buttonText: PropTypes.string,
	buttonTextConfig: PropTypes.object,
	buttonAction: PropTypes.string,
	buttonLink: PropTypes.string,
	onButtonTextChange: PropTypes.func,
	textEditable: PropTypes.bool,
	onTextChange: PropTypes.func,
	textKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	buttonTextKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mobileAlignment: PropTypes.string,
	mobileButtonWidth: PropTypes.string,
}
Content.defaultProps = {
	classes: undefined,
	buttonLink: null,
}

export default memo(Content)
